import { DefaultInput } from './index'

export default {
    email: new DefaultInput(),
    username: new DefaultInput(),
    password: new DefaultInput(),
    first_name: new DefaultInput(),
    last_name: new DefaultInput(),
    title: new DefaultInput(),
    status: new DefaultInput(),
}
